import React from 'react';
import PropTypes from 'prop-types';
import MainMenuItem from './mainMenuItem';
import appHistory from '../../utils/appHistory';
const DirectFormMenuItem = ({
  identifier,
  title,
  icon: _icon = 'plus-circle',
  directFormType,
  showIcons: _showIcons = true
}) => {
  const handleClick = event => {
    if (event !== null && event !== void 0 && event.preventDefault) {
      // MainMenuItem defaults href to "#"; keep navigation authoritative.
      event.preventDefault();
    }
    appHistory.push(`/directForms/new/${directFormType}`);
  };
  return /*#__PURE__*/React.createElement(MainMenuItem, {
    className: `t-h-nav-${identifier}`,
    key: `${identifier}Tab`,
    href: `/#/directForms/new/${directFormType}`,
    onClick: handleClick,
    glyph: _showIcons ? _icon : '',
    title: title
  });
};
DirectFormMenuItem.propTypes = {
  identifier: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  directFormType: PropTypes.string.isRequired,
  showIcons: PropTypes.bool
};
export { DirectFormMenuItem as TestDirectFormMenuItem };
export default DirectFormMenuItem;